import { render, staticRenderFns } from "./serveList.vue?vue&type=template&id=08feee17&scoped=true&"
import script from "./serveList.vue?vue&type=script&lang=js&"
export * from "./serveList.vue?vue&type=script&lang=js&"
import style0 from "./serveList.vue?vue&type=style&index=0&id=08feee17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08feee17",
  null
  
)

export default component.exports